import axiosInstance from "../config/AxiosConfig";

export const orderRepository = {
  createOrder: async (data) => {
    return await axiosInstance.post("/orders", data);
  },
  findAll: async (page) => {
    return await axiosInstance.get(`/orders?page=${page}`);
  },
  findByStatus: async (status, page) => {
    return await axiosInstance.get(`/orders/status/${status}?page=${page}`);
  },
  findById: async (id) => {
    return await axiosInstance.get(`/orders/${id}`);
  },
  deleteItemFromOrder: async (orderId, itemId) => {
    return await axiosInstance.delete(`/orders/${orderId}/item/${itemId}`);
  },
  updateOrderStatus: async (details) => {
    return await axiosInstance.put(`/orders/status`, details);
  },
  deleteOrder: async (orderId) => {
    return await axiosInstance.delete(`/orders/${orderId}`);
  },
  search: async (query, page) => {
    return await axiosInstance.post(`/orders/search/${query}?page=${page}`);
  },
  findOngoingOrders: async () => {
    return await axiosInstance.get(`/orders/analytics/ongoing`);
  },
  findNewOrders: async () => {
    return await axiosInstance.get(`/orders/analytics/new`);
  },
};
